export default "__VITE_PUBLIC_ASSET__34b4ec40__"